import React, {Component, createRef} from 'react';
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { deepArraySearch } from "../../../utils/deepSearch";
import apiUrl from "../../../shared/config";
import './ExampleGamesInput.css';
import {InfoOutlined} from "@material-ui/icons";
import {Tooltip} from "@material-ui/core";
import DeleteButton from "./ExampleGameInputButtons/DeleteButton";
import UpgradeButton from "./ExampleGameInputButtons/UpgradeButton";
import TextAreaWithTabs from "../../UI/TextAreaWithTabs/TextAreaWithTabs";
import {selectRedShadow, styleRedShadow} from "../../../utils/commonStyles"
import {validStringField} from "../../../utils/utils";
import * as actionTypes from "../../../store/actions/actionTypes";
import {connect} from "react-redux";
import EditHistoryWrapper from "../../UI/EditHistoryPanel/EditHistoryWrapper";

class ExampleGamesInput extends Component {
    state = {
        games: [],
        example_games: [],
        infoHovered: false,
        delIsOpen: false,
        isOrderIdMapped: false,
        problemOptions: [],
        active_histories: []
    };

    lastExampleGameRef = createRef();

    componentDidMount() {
        if (this.state.games.length === 0) {
            axios.get(apiUrl + 'Games/getGames')
                .then(response => {
                    this.setState({ games: response.data });
                });
        }

        // this adds a stub example game when you do not have an example game on the pattern
        if (!this.props.exampleGames || (this.props.exampleGames && this.props.exampleGames.length === 0)) {
            this.props.exampleGamesUpdate([{
                pattern_id: null,
                game_id: null,
                example_description: "",
                secondary_games: [], // Ensure secondary_games is defined
                design_problems: [],
                isOrderIdMapped: true
            }])
        }

        this.setState({
            example_games: this.props.exampleGames || [],
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.exampleGames !== this.props.exampleGames) {
            // this adds a stub example game when you do not have an example game on the pattern
            if (!this.props.exampleGames || (this.props.exampleGames && this.props.exampleGames.length === 0)) {
                this.props.exampleGamesUpdate([{
                    pattern_id: null,
                    game_id: null,
                    example_description: "",
                    secondary_games: [], // Ensure secondary_games is defined
                    design_problems: [],
                    isOrderIdMapped: true
                }])
            }

            this.setState({
                example_games: this.props.exampleGames || [],
            });
        }

        if (this.props.designProblems && this.props.designProblems.length > 0 && this.props.designProblems[0]['order_id'] && this.props.exampleGames && this.props.exampleGames.length > 0 && !this.props.exampleGames[0].isOrderIdMapped) {
            this.props.exampleGamesUpdate(
                this.props.exampleGames.map((game) => {
                    return {
                        ...game,
                        design_problems: this.mapDesignProblemIdsToOrderIds(game.design_problems),
                        isOrderIdMapped: true
                    }
                })
            )
        }

        if (this.props.designProblems && prevProps.designProblems !== this.props.designProblems) {
            const problemOptions = this.props.designProblems && this.props.designProblems.length > 1 ?
                this.props.designProblems.map((problem, index) => ({ value: problem.order_id, label: "Design Problem " + (index + 1) }))
                : []
            this.setState({problemOptions: problemOptions})
        }

    }

    mapDesignProblemIdsToOrderIds = (design_problems) => {
        return design_problems.map((problem_id) => {
            let problem_object = this.props.designProblems.find((problem) => problem.design_problem_id === problem_id);
            if (problem_object) {
                return problem_object.order_id;
            } else {
                return 0;
            }
        })
    }

    addExampleGame = (gameId = null) => {
        this.props.exampleGamesUpdate([
            ...this.state.example_games,
            {
                pattern_id: null,
                game_id: gameId,
                example_description: "",
                secondary_games: [], // Ensure secondary_games is defined
                design_problems: [],
                isOrderIdMapped: true
            }])
        this.setState(prevState => ({
            example_games: [
                ...prevState.example_games,
                {
                    pattern_id: null,
                    game_id: gameId,
                    example_description: "",
                    secondary_games: [], // Ensure secondary_games is defined
                    design_problems: [],
                    isOrderIdMapped: true
                }]
        }), () => {
            if (gameId !== null && this.lastExampleGameRef.current) {
                this.lastExampleGameRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        });
    };

    addSecondaryExampleGame = (exampleGameIndex) => {
        this.setState(prevState => {
            const example_games = [...prevState.example_games];
            example_games[exampleGameIndex].secondary_games.push({
                game_id: null,
                game_name: "",
                game_description: ""
            });
            this.props.exampleGamesUpdate(example_games)
            return { example_games };
        });
    }

    deleteSecondaryExampleGame = (game, games, currIndex) => {
        this.setState(prevState => {
            const example_games = [...prevState.example_games];
            const secondaryGames = [...games];
            const index = deepArraySearch(secondaryGames, game);
            if (index >= 0) {
                secondaryGames.splice(index, 1);
                example_games[currIndex].secondary_games = secondaryGames;
            } else {
                console.error("Failed to delete secondary game");
            }
            this.props.exampleGamesUpdate(example_games)
            return { example_games };
        });
    }

    handlePopoverToggle = (nextShow) => {
        this.setState({ infoHovered: nextShow });
    }

    arraySearch(arr, val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    handleHistoryChange = (historyChange) => {
        if (historyChange) {
            this.props.exampleGamesUpdate(
                this.props.exampleGames.map((game) => {
                    if (game.game_id === historyChange.game_id) {
                        return { ...game, ...historyChange }
                    } else {
                        return game
                    }
                })
            )
        }
    }

    handleActiveHistory = (activeHistories) => {
        this.setState({active_histories: activeHistories})
    }



    render() {

        const deleteButton = (example_games_index, currGame = null) => {
            return <DeleteButton
                onDelete={() => {
                    if (currGame) {
                        this.deleteSecondaryExampleGame(currGame,
                            [...this.state.example_games][example_games_index].secondary_games,
                            example_games_index
                        );
                    } else {
                        // Mark the game that had its delete button clicked as "Deleted"
                        let mapped_array = this.state.example_games.map((game, index) => {
                            if (example_games_index === index) {
                                return {
                                    ...game,
                                    deleted: 1
                                }
                            } else {
                                return game
                            }
                        });
                        // Entirely filter out any deleted games that don't have a pattern_id, meaning the game doesn't
                        // have an existing entry in the database
                        let filtered_array = mapped_array.filter((game) => {
                            return game.deleted !== 1 || game.pattern_id;
                        })

                        // Remove any delete games from the active_histories state
                        let filtered_active_histories = this.state.active_histories.filter((id) => {
                            return filtered_array.filter((game) => {return game.deleted !== 1})
                                .map((game) => {return game.game_id}).includes(id)
                        })

                        this.setState({example_games: filtered_array, active_histories: filtered_active_histories});
                        this.props.exampleGamesUpdate(filtered_array);
                    }
                }}
            />
        }

        const { games, example_games } = this.state;

        let used_game_ids = example_games.filter((game) => { return game.deleted !== 1}).map((game) => {return game.game_id})

        let exampleGamesInputElement = null;
        if (games && games.length) {
            const gameOptions = games.map(game => ({ value: game.game_id, label: game.game_name }));

            if (example_games && example_games.filter((game) => {return game.deleted !== 1}).length) {

                exampleGamesInputElement = (
                    <>
                        <dd className="col-sm-9">
                            {example_games.map((game, example_games_index) => {
                                if (game.deleted === 1) {
                                    return "";
                                }
                                const allBlank = !validStringField(game.example_description) && !(game.game_id && game.game_id > 0) && game.secondary_games.length === 0 && game.design_problems.length === 0;
                                const example_game_id = game.game_id;
                                const default_index = this.arraySearch(gameOptions, example_game_id);
                                let default_value = { label: "Select a game that uses this pattern." };
                                if (example_game_id !== null) {
                                    default_value = gameOptions[default_index];
                                }
                                let defaultValues = this.state.problemOptions && this.props.designProblems && this.props.designProblems.length > 0
                                    ? game.design_problems.map(order_id => {
                                        return this.state.problemOptions.find(option => option.value === order_id)
                                            || ''
                                    }) : ''
                                return (
                                    <div className="example-games-block"
                                         key={example_game_id + " " + example_games_index}
                                         ref={example_games_index === example_games.length - 1 ? this.lastExampleGameRef : null}>
                                        <Select
                                            isDisabled={this.state.active_histories.includes(example_game_id)}
                                            className="example-games-select-semi-full"
                                            styles={selectRedShadow((game.game_id && game.game_id > 0) || allBlank)}
                                            defaultValue={{
                                                value: game.game_id,
                                                label: default_value ? default_value.label : game.game_name,
                                                isFixed: true,
                                                isDisabled: true
                                            }}
                                            options={gameOptions.filter((option) => {
                                                return !used_game_ids.includes(option.value)
                                            })}
                                            onChange={(val) => {
                                                // Copy the example games
                                                let example_games_local = [...this.state.example_games];
                                                // Change the game_id of the example game that had its selector changed
                                                example_games_local[example_games_index] = {
                                                    ...game,
                                                    game_id: val.value
                                                };
                                                // If there is a deleted game with the selected game_id, filter it out
                                                example_games_local = example_games_local.filter((game) => {
                                                    return game.game_id !== val.value || !game.deleted
                                                })
                                                // Add a "deleted" entry for the game that was previously selected
                                                example_games_local.push({...game, deleted: 1})
                                                // Filter out any "deleted" entries that don't exist in the database
                                                // (i.e., they don't have a pattern_id)
                                                example_games_local = example_games_local.filter((game) => {
                                                    return game.deleted !== 1 || game.pattern_id;
                                                })
                                                this.setState({example_games: example_games_local});
                                                this.props.exampleGamesUpdate(example_games_local); // Uncomment this if needed
                                            }}
                                        />
                                        <div style={{
                                            display: "flex",
                                            height: "35px",
                                        }}>{deleteButton(example_games_index)}</div>
                                        <div className="example-description" style={{marginBottom: 5}}>
                                            <TextAreaWithTabs
                                                rows="4"
                                                style={styleRedShadow(validStringField(game.example_description) || allBlank)}
                                                placeholder="How is this pattern applied in this game?"
                                                value={game.example_description}
                                                onChange={(event) => {
                                                    let example_games_local = [...this.state.example_games];
                                                    example_games_local[example_games_index] = {
                                                        ...game,
                                                        example_description: event.target.value
                                                    };
                                                    this.setState({example_games: example_games_local});
                                                    this.props.exampleGamesUpdate(example_games_local);
                                                }}/>
                                            <EditHistoryWrapper
                                                style={{marginBottom: 10}}
                                                token={this.props.token}
                                                history_id={game.history_id}
                                                pattern_id={game.pattern_id}
                                                component_id={game.game_id}
                                                handleHistoryChange={this.handleHistoryChange}
                                                handleActiveHistory={this.handleActiveHistory}
                                                activeHistories={this.state.active_histories}
                                                component_text_field={game.example_description}
                                                component={game}
                                                flag={"PRIMARY_GAME"}
                                                keyStr={"example-game-history-" + game.game_id}
                                                isActive={this.state.active_histories.includes(game.game_id)}
                                                openUserModal={() => {
                                                    this.props.setSelectedUserId(game.editor_user_id);
                                                    this.props.openUserModal();
                                                }}
                                            />
                                        </div>
                                        {this.props.designProblems && this.props.designProblems.length > 1 && game.isOrderIdMapped && this.state.problemOptions && this.state.problemOptions.length === this.props.designProblems.length
                                            ? <Select
                                                className="example-games-select-full"
                                                isMulti={true}
                                                defaultValue={defaultValues}
                                                placeholder="Which design problems are solved by this example?"
                                                options={this.state.problemOptions}
                                                onChange={(val) => {
                                                    let example_games_local = [...this.state.example_games];
                                                    example_games_local[example_games_index] = {
                                                        ...game,
                                                        design_problems: val ? val.map(e => e.value) : []
                                                    };
                                                    this.setState({ example_games: example_games_local });
                                                    this.props.exampleGamesUpdate(example_games_local); // Uncomment this if needed
                                                }}
                                            /> : ''}
                                        <div>
                                            <div style={{display: 'flex', width: '100%'}}>
                                                <div style={{flex: 1, marginTop: "20px"}}>
                                                    <h3 className="secondary-section-title">Secondary Games</h3>
                                                </div>
                                                <div style={{flex: 1, marginTop: "20px"}}>
                                                    <OverlayTrigger
                                                        trigger="click"
                                                        rootClose
                                                        rootCloseEvent="click"
                                                        placement='bottom'
                                                        onToggle={(nextShow) => this.handlePopoverToggle(nextShow)}
                                                        overlay={
                                                            <Popover id='pattern-game-description'>
                                                                <Popover.Content className="game-description">
                                                                    A Secondary game is a game that implements the
                                                                    pattern in the same way the example game above does.
                                                                </Popover.Content>
                                                            </Popover>
                                                        }
                                                    >
                                                        <Tooltip title={this.state.infoHovered ? "" : "Info"} placement={"top"}>
                                                            <InfoOutlined className={"new-info-icon"} style={{height: "35px"}}/>
                                                        </Tooltip>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                            {game.secondary_games.map((currGame, secIndex) => (
                                                <div key={secIndex} className="secondary-game-container">
                                                    <Select
                                                        className="secondary-games-select"
                                                        styles={selectRedShadow(currGame.game_id)}
                                                        value={currGame.game_id ? { value: currGame.game_id, label: currGame.game_name } : null}
                                                        options={gameOptions}
                                                        onChange={(val) => {
                                                            let example_games_local = [...this.state.example_games];
                                                            let secondaryGamesCurr = example_games_local[example_games_index].secondary_games;
                                                            let index = deepArraySearch(secondaryGamesCurr, currGame);
                                                            if (index >= 0) {
                                                                secondaryGamesCurr[index] = {
                                                                    game_name: val.label,
                                                                    game_id: val.value,
                                                                };
                                                                this.props.exampleGamesUpdate(example_games_local);
                                                            }
                                                        }}
                                                    />
                                                    {deleteButton(example_games_index, currGame)}
                                                    <UpgradeButton onUpgrade={() => {
                                                        this.deleteSecondaryExampleGame(currGame,
                                                            [...this.state.example_games][example_games_index].secondary_games,
                                                            example_games_index);
                                                        this.addExampleGame(currGame.game_id);
                                                    }} />
                                                </div>
                                            ))}
                                            <Button onClick={() => this.addSecondaryExampleGame(example_games_index)} style={{marginTop: "8px"}}>Add
                                                Secondary Game</Button>
                                        </div>
                                    </div>
                                );
                            })}
                        </dd>
                        <dt className="col-sm-3"></dt>
                    </>
                );
            }
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Example Games</label></dt>
                {exampleGamesInputElement}
                <dd className="col-sm-9">
                    <Button className="col-sm-12" variant="outline-primary" onClick={() => this.addExampleGame()}>Add Example Game</Button>
                </dd>
            </dl>
        );
    }
}


const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        openUserModal: () => dispatch({type: actionTypes.OPEN_USER_MODAL}),
        setSelectedUserId: (userId) => dispatch({type: actionTypes.SELECT_USER, userId: userId})
    }
}

export default connect(mapStateToProps, mapDispatchToProps) (ExampleGamesInput);
